// extracted by mini-css-extract-plugin
module.exports = {"colorLegend":"_2wJe7bo _1LFpV2n","colorLegendItem":"_1w9UJDm","colorChip":"_3rbYccN"};